var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M9.42 2.023c-.066.009-.291.037-.5.061a8.724 8.724 0 0 0-1.8.456 8.014 8.014 0 0 0-5.028 6.28c-.093.598-.093 1.762 0 2.36.551 3.531 3.311 6.257 6.828 6.745.489.068 1.671.068 2.16 0a8.203 8.203 0 0 0 3.42-1.322l.4-.274 2.78 2.772c2.691 2.683 2.787 2.774 2.997 2.835.271.08.375.08.633.003.279-.083.546-.35.629-.629.077-.258.077-.362-.003-.633-.061-.21-.152-.306-2.835-2.997l-2.772-2.78.274-.4a7.822 7.822 0 0 0 1.136-2.518c.185-.726.239-1.17.239-1.982s-.054-1.256-.239-1.982a7.988 7.988 0 0 0-6.521-5.919c-.389-.06-1.559-.11-1.798-.076m1.304 2.021c.733.095 1.39.303 2.068.656.558.291.977.6 1.442 1.066a5.89 5.89 0 0 1 1.584 2.793 5.965 5.965 0 0 1-.199 3.542 7.43 7.43 0 0 1-.764 1.423 7.356 7.356 0 0 1-1.331 1.331 6.006 6.006 0 0 1-4.965.963 6.265 6.265 0 0 1-2.083-.963 7.356 7.356 0 0 1-1.331-1.331A6.159 6.159 0 0 1 4 10c0-.97.231-1.891.7-2.792.291-.558.6-.977 1.066-1.442A5.969 5.969 0 0 1 9.16 4.06a6.763 6.763 0 0 1 1.564-.016"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b9e616a6.svg";
export { ForwardRef as ReactComponent };